import React from 'react'

import { Redirect, Route, Switch } from 'react-router'

import { ComponentsPage } from '../pages/ComponentsPage'
import { EmailSentPage} from '../pages/EmailSentPage'
import { ForgotPasswordPage } from '../pages/ForgotPasswordPage'
import { LoginPage } from '../pages/LoginPage'
import { PainRatingPage } from '../pages/PainRatingPage'
import { UpdatePasswordPage} from '../pages/UpdatePasswordPage'

const PrivateRoute = (rest: any) => (
  <Route {...rest} render={props => {
    return (
      <Redirect to={`/login?referrer=${props.location.pathname}`} />
    )
    } }
  />
)

export const GuestRoutes = () =>
  <Switch>
    <PrivateRoute path="/contents/:screenNo"  />
    <PrivateRoute path="/choose-site" />
    <PrivateRoute path="/welcome-back" />
    <PrivateRoute path="/kids" />
    <PrivateRoute path="/kids-faq" />
    <PrivateRoute path="/kids-video" />
    <PrivateRoute path="/kids-tour" />
    <PrivateRoute path="/kids-games" />
    <PrivateRoute path="/kids-activities" />
    <PrivateRoute path="/intake-1" />
    <PrivateRoute path="/intake-2" />
    <PrivateRoute path="/intake-3" />
    <PrivateRoute path="/review-1" />
    <PrivateRoute path="/review-2" />
    <PrivateRoute path="/review-3" />
    <PrivateRoute path="/review-4" />
    <PrivateRoute path="/components" />
    <PrivateRoute path="/contents/:screenNo" />
    <PrivateRoute path="/p/:token" />
    <PrivateRoute path="/HCP_Welcome" />
    <PrivateRoute path="/HCP1-patientInfo" />
    <PrivateRoute path="/HCP3-patientInfo" />
    <Redirect path="/" exact={true} to="/login" />
    <Route path="/login" component={LoginPage} />
    <Route path="/forgot-password" component={ForgotPasswordPage} />
    <Route path="/components" component={ComponentsPage} />
    <Route path="/p/:token" component={PainRatingPage} />
    <Route path="/email-sent" component={EmailSentPage} />
    <Route path="/reset-password" component={UpdatePasswordPage} />
    <Redirect to="/login" />
  </Switch>



// WEBPACK FOOTER //
// ./src/routes/GuestRoutes.tsx